import React, {useState} from 'react'
import {Col, Input, Label, Row} from "reactstrap";
import {TT_DELETE} from "../../../../components/i18n/toolTips";
import {GenericButton} from "../../../../components/buttons/customButtons";



const RecurringDay = (props) => {
    const {
        day,
        udn,
        onChange,
        onRemoveDay,
    } = props

    const [hourStart, setHourStart] = useState(props?.hourStart || null)
    const [hourEnd, setHourEnd] = useState(props?.hourEnd || null)
    const [hasError, setHasError] = useState(day?.hasError ||  false);
    const [errorMessage, setErrorMessage] = useState(day?.errorMessage || '');


    const setUdnTimes = () => {
        if(!udn) return

        setHourStart(udn?.openingTime)
        setHourEnd(udn?.closingTime)
        setHasError(false)
        setErrorMessage('')
        onChange(day?.id, udn?.openingTime, udn?.closingTime, false)
    }


    const onHourStartChange = ({ target:{ value } }) => {
        setHourStart(value)

       if(!value){
           setHasError(true)
           setErrorMessage('Debe seleccionar una hora de apertura')
           onChange(day?.id, value, hourEnd, true)
           return
       }


       if(!hourEnd){
            setHasError(true)
            setErrorMessage('Debe seleccionar una hora de cierre')
        } else if (value > hourEnd) {
            setHasError(true)
            setErrorMessage('La hora de cierre debe ser mayor a la de apertura')
        } else {
            setHasError(false)
            setErrorMessage('')
        }


        onChange(day?.id, value, hourEnd, hasError)
    }


    const onEndHourChange = ({ target:{ value } }) => {

        setHourEnd(value)

        if(!value){
            setHasError(true)
            setErrorMessage('Debe seleccionar una hora de cierre')
            onChange(day?.id, hourEnd, value, true)
            return
        }


        if(!hourStart){
            setHasError(true)
            setErrorMessage('Debe seleccionar una hora de apertura')
        } else if (value < hourStart) {
            setHasError(true)
            setErrorMessage('La hora de cierre debe ser mayor a la de apertura')
        } else {
            setHasError(false)
            setErrorMessage('')
        }

        onChange(day?.id, hourEnd, value, hasError)
    }

    const onDelete = () => onRemoveDay(day?.id)


    return <div className={` blockquote ${hasError ? 'border-danger' : ''} schedule-container`}>
        <Row>
            <Col md={2}>
                <Label>{day?.label}</Label>
            </Col>
            <Col sm={3}>
                <div style={{cursor: 'pointer'}}>
                    <div>Usar los horarios del la UDN:</div>
                    <div className={'link'} onClick={setUdnTimes} >{udn?.openingTime} - {udn?.closingTime} <i className="fa fa-arrow-right" aria-hidden="true"/></div>
                </div>
            </Col>
            <Col>
                <Row>
                    <Col>
                        <label className={"mr-1em"}>Hora de inicio:</label>
                        <Input
                            name={'hourStart'}
                            bsSize="sm"
                            type={"time"}
                            className={"form-control d-inline-block w-auto"}
                            value={hourStart}
                            onChange={onHourStartChange}
                        />
                    </Col>
                    <Col>
                        <label className={"mr-1em"}>Hora de fin:</label>
                        <Input
                            name={'hourEnd'}
                            bsSize="sm"
                            type={"time"}
                            className={"form-control d-inline-block w-auto"}
                            readOnly={!hourStart}
                            value={hourEnd}
                            onChange={onEndHourChange}/>
                    </Col>
                </Row>
            </Col>

            <Col sm={1} className={'pt-3'}>
                <GenericButton
                    style={'danger-secondary'}
                    toolTip={TT_DELETE}
                    icon={'fa-close'}
                    permission={'delete'}
                    onClick={onDelete}
                />
            </Col>
        </Row>

        {
            hasError && <div className={'text-danger schedule-danger'}>
                <i className="fa fa-exclamation-circle" aria-hidden="true"/>
                <div className={"alert alert-danger schedule-error-message"}>{errorMessage}</div>
            </div>
        }

    </div>

}

export default RecurringDay